// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"689bb407","455":"99f583d8","977":"463f185e"}[chunkId] + ".chunk.js";
};